import { z } from 'zod';

export type CarSendForModerationForm = {
    auction_rules_accepted: boolean,
};

export type CarSendToModerationErrors = {
    documents?: string[],
    photos?: string[],
    videos?: string[],
    auction_rules_accepted?: string[],
};

export const CarSendToModerationErrorsSchema = z.object({
    documents: z.array(z.string()).optional(),
    photos: z.array(z.string()).optional(),
    videos: z.array(z.string()).optional(),
    auction_rules_accepted: z.array(z.string()).optional(),
});

export function mapCarSendForModerationFormToFormData(sendForModerationForm: CarSendForModerationForm): FormData {
    const formData = new FormData();

    if (sendForModerationForm.auction_rules_accepted !== undefined) {
        formData.append('auction_rules_accepted', sendForModerationForm.auction_rules_accepted ? '1' : '0');
    }

    return formData;
}
